import { Container, Row, Col } from 'react-bootstrap';
import Button from '../../../../ntisui/Atoms/Buttons';
import { IConfirmStep2 } from '../types/IConfirmStep2';
import { ButtonVariant } from '../../../template/types/IHeader';
import './_ConfirmSubscriptionStep2.scss';

function ConfirmSubscriptionStep2({
  onButtonClick,
  mainContent,
  subContent,
  image,
  showInfo,
  title,
  buttonName,
}: IConfirmStep2) {
  return (
    <Container
      data-testid="confirm-subscription-step2"
      className="confirm-subscription-step2"
    >
      <Row>
        <Col>
          {image && <img src={image} alt="union" />}
          <h3>{title}</h3>
          <p>{mainContent}</p>
          <p>{subContent}</p>
        </Col>
      </Row>

      {showInfo && (
        <Col className="info">
          <i className="fa fa-info-circle" aria-hidden="true"></i>
          <p>{showInfo}</p>
        </Col>
      )}
      <Col>
        <Button
          variant={ButtonVariant.Primary}
          className="continue-button"
          label={buttonName}
          onClick={() => {
            onButtonClick();
          }}
        />
      </Col>
    </Container>
  );
}

export default ConfirmSubscriptionStep2;
